import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_GetLendingAnalysisSummaryCommand, se_GetLendingAnalysisSummaryCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class GetLendingAnalysisSummaryCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("Textract", "GetLendingAnalysisSummary", {})
    .n("TextractClient", "GetLendingAnalysisSummaryCommand")
    .f(void 0, void 0)
    .ser(se_GetLendingAnalysisSummaryCommand)
    .de(de_GetLendingAnalysisSummaryCommand)
    .build() {
}
